import React from 'react';

function BracketSeedMark({ size = 36, variant = 'dark' }: { size?: number; variant?: 'dark' | 'light' }) {
  const green = '#92de71';
  const innerShade = variant === 'light' ? 'rgba(240,243,240,0.4)' : 'rgba(6,18,12,0.3)';
  const bracketOpacity = variant === 'light' ? 0.6 : 0.5;

  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
      style={{ flexShrink: 0 }}
    >
      <polyline points="19,8 8,24 19,40" stroke={green} strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" opacity={bracketOpacity} />
      <polyline points="29,8 40,24 29,40" stroke={green} strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" opacity={bracketOpacity} />
      <polygon points="24,13 31,24 24,35 17,24" fill={green} />
      <polygon points="24,18 28,24 24,30 20,24" fill={innerShade} />
    </svg>
  );
}

interface BracketSeedLogoProps {
  variant?: 'dark' | 'light';
  showWordmark?: boolean;
  size?: number;
  className?: string;
}

export function BracketSeedLogo({ variant = 'dark', showWordmark = true, size = 32, className = '' }: BracketSeedLogoProps) {
  const textColor = variant === 'light' ? '#0A0F0E' : '#EAF1EC';
  const accentColor = '#92de71';
  const fontSize = Math.round(size * 0.56);

  return (
    <span
      style={{ display: 'inline-flex', alignItems: 'center', gap: Math.round(size * 0.34), textDecoration: 'none', lineHeight: 1 }}
      className={className}
    >
      <BracketSeedMark size={size} variant={variant} />
      {showWordmark && (
        <span style={{ fontFamily: 'Inter, sans-serif', fontWeight: 700, fontSize, letterSpacing: '-0.02em', color: textColor, whiteSpace: 'nowrap' }}>
          Code <span style={{ color: accentColor }}>Garden</span>
        </span>
      )}
    </span>
  );
}
